import React from "react";

export default function GroupDetailModal({
  group,
  closeLabel,
  description,
  coverImageUrl,
  coverImageAlt,
  coverObjectPosition,
  coverScale = 1,
  coverInteractive = false,
  headerBadges,
  stats,
  roleMessage,
  actions,
  invitePanel,
  memberListTitle,
  memberCount,
  memberCountLabel,
  onCoverClick,
  onClose,
  children,
}) {
  if (!group) return null;

  return (
    <div className="groups-detail-backdrop" onClick={onClose}>
      <div
        className="groups-detail-modal"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className="groups-detail-close"
          onClick={onClose}
          aria-label={closeLabel}
        >
          &times;
        </button>

        {coverImageUrl ? (
          coverInteractive ? (
            <button
              type="button"
              className="groups-detail-cover-button"
              onClick={onCoverClick}
            >
              <img
                src={coverImageUrl}
                alt={coverImageAlt || group.name}
                className="groups-detail-cover"
                style={{
                  objectPosition: coverObjectPosition,
                  transform: `scale(${coverScale})`,
                }}
              />
            </button>
          ) : (
            <div className="groups-detail-cover-wrap">
              <img
                src={coverImageUrl}
                alt={coverImageAlt || group.name}
                className="groups-detail-cover"
                style={{
                  objectPosition: coverObjectPosition,
                  transform: `scale(${coverScale})`,
                }}
              />
            </div>
          )
        ) : null}

        <div className="groups-detail-header">
          <div>
            <div className="groups-card-tags">
              {headerBadges}
            </div>
            <h2>{group.name}</h2>
            <p className="groups-detail-description">{description}</p>
          </div>
        </div>

        <div className="groups-detail-stats">
          {stats}
        </div>

        <p className="groups-detail-role">{roleMessage}</p>

        <div className="groups-detail-actions">
          {actions}
        </div>

        {invitePanel}

        <div className="groups-members-section">
          <div className="groups-members-header">
            <h3>{memberListTitle}</h3>
            <span className="groups-members-count">
              {memberCount} {memberCountLabel}
            </span>
          </div>

          <div className="groups-members-list">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
